import { createContext } from 'react';
import { UserGeneralData } from '../interfaces/UserGeneralData';
 

export const UserContext = createContext({} as UserGeneralData);